<h3 mat-dialog-title>{{title}}</h3>
<div mat-dialog-content>
<form [formGroup]="addFormGroup">
    <mat-table [dataSource]="data">
        <ng-container matColumnDef="Area">
            <mat-header-cell *matHeaderCellDef>Area</mat-header-cell>
            <mat-cell *matCellDef="let d" class="equipment">
                <div *ngIf="(d.Area != '')">{{d.Area}}</div>

                <mat-form-field *ngIf="(d.Area == '')" floatLabel="never">
                    <textarea matInput cdkTextareaAutosize placeholder="New Area" formControlName="NewArea"></textarea>
                </mat-form-field>
            </mat-cell>
        </ng-container> 

        <ng-container matColumnDef="Section">
            <mat-header-cell *matHeaderCellDef>Section</mat-header-cell>
            <mat-cell *matCellDef="let d" style="margin-left: 8px;"  class="equipment">
                <div *ngIf="(d.Section != '')">{{d.Section}}</div>

                <mat-form-field  *ngIf="(d.Section == '')" floatLabel="never">
                    <textarea  matInput cdkTextareaAutosize placeholder="New Section" formControlName="NewSection"></textarea>
                </mat-form-field>
            </mat-cell>
        </ng-container>    

        
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
            <mat-cell *matCellDef="let d; let i = index">
            <button [disabled]="!adminFlag"  *ngIf="(d.Area != '')" mat-button color="warn" (click)="delete(d.Area, d.Section)"><mat-icon>delete_forever</mat-icon>Delete Equipment Bypass</button>
            <button [disabled]="!adminFlag"  *ngIf="(d.Area == '')" mat-button color="primary" (click)="add()"><mat-icon>add_circle</mat-icon>Add Equipment Bypass</button>
            </mat-cell>
        </ng-container> 
        
        

        <mat-header-row *matHeaderRowDef="displayedObjectColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedObjectColumns;"></mat-row>      
    </mat-table>
</form>
</div>   
<div mat-dialog-actions>
    <button mat-raised-button (click)="close()">Close</button>
</div>